<template>
  <h2 class="heading-2 mb-8">
    {{ i18n(translations.title) }}
  </h2>

  <div class="body-1 mb-16">
    {{ i18n(translations.subtitle) }}
  </div>

  <div class="mb-16 space-y-22">
    <div class="heading-3">{{ contactDetails?.businessName }}</div>

    <div class="body-1 flex flex-col">
      <span v-if="contactDetails?.addressLine1">
        {{ contactDetails?.addressLine1 }}
      </span>
      <span v-if="contactDetails?.addressLine2">
        {{ contactDetails?.addressLine2 }}
      </span>
      <span v-if="contactDetails?.city">{{ contactDetails?.city }}</span>
      <span v-if="contactDetails?.postalCode">
        {{ contactDetails?.postalCode }}
      </span>
      <span v-if="contactDetails?.country">
        {{ contactDetails?.country }}
      </span>
    </div>

    <div class="flex flex-col">
      <span v-if="contactDetails?.phone">
        <b class="text-static-default-low body-1"
          >{{ i18n(translations.phone) }}
        </b>
        {{ contactDetails?.phone }}
      </span>
      <span v-if="contactDetails?.email">
        <b class="text-static-default-low body-1"
          >{{ i18n(translations.email) }}
        </b>
        {{ contactDetails?.email }}
      </span>
      <span v-if="contactDetails?.website">
        <b class="text-static-default-low body-1"
          >{{ i18n(translations.website) }}
        </b>
        {{ contactDetails?.website }}
      </span>
    </div>
  </div>

  <RevButton variant="secondary" @click="$emit('edit')">
    {{ i18n(translations.editButton) }}
  </RevButton>
</template>

<script setup lang="ts">
import type { GetDsaContactDetails } from '@backmarket/http-api/src/api-specs-seller-backoffice/seller-profile/merchant-profile-page.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import translations from './HasContactDetailBlockContent.translations'

defineProps<{
  contactDetails: GetDsaContactDetails['contactDetails']
}>()

const i18n = useI18n()

defineEmits<{
  edit: []
}>()
</script>
